<template>
    <modal @close="closeModal" dusk="private-whois-enable-confirm">
        <div class="u-margin-bottom">
            <div class="page-block__item">
                <div class="page-block__item-content">
                    {{
                        trans('domain.whois.private-enable-confirm', {
                            domain: this.domain
                        })
                    }}
                </div>
            </div>

            <div class="page-block__item">
                <div class="page-block__item-content">
                    <div class="layout">
                        <div class="layout__item u-1/3-desk">
                            <span class="page-block__item-content-title">
                                {{ trans('domain.whois.private-enable-pricing') }}
                            </span>
                        </div>
                        <div class="layout__item u-2/3-desk">
                            <price-display :price="privateWhoisPrice.regular_price" class="product__item-actions-price" />
                        </div>
                    </div>
                    <div class="layout">
                        <div class="layout__item u-1/3-desk">
                            <span class="page-block__item-content-title">
                                {{ trans('domain.period') }}
                            </span>
                        </div>
                        <div class="layout__item u-2/3-desk">
                            {{ trans('order.periods.' + privateWhoisPrice.period) }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="layout__item">
                <checkbox
                    v-model="confirmed"
                    :label="trans('domain.whois.private-enable-confirm-checkbox')"
                    name="private_whois_confirm"
                    class="u-margin-bottom-narrow"
                />
            </div>
        </div>

        <div class="modal__nav">
            <button class="btn btn--ghost-gray | u-margin-right" @click="closeModal">
                {{ trans('action.cancel') }}
            </button>
            <button class="btn btn--blue-record" type="submit" @click="enablePrivateWhois" :disabled="!confirmed">
                {{ trans('domain.whois.private-enable') }}
            </button>
        </div>
    </modal>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import { EventBus } from 'relapp-event';
import PriceDisplay from '@/components/Price/PriceDisplay.vue';
import { Modal } from 'relapp-modal';
import { WhoisApi } from 'relapp-technical-management';

export default {
    components: {
        Modal,
        PriceDisplay
    },
    props: {
        domain: {
            type: String,
            required: true
        }
    },
    computed: {
        ...mapGetters({
            getProductByName: 'products/productByName'
        }),

        /**
         * Get the product by service name from the order.
         *
         * @return {object}
         */
        privateWhoisPrice() {
            let product = this.getProductByName('Privacy bescherming');

            return product.prices.filter(function (price) {
                return price.type == 'prolongation' && price.period == 12;
            })[0];
        },

        /**
         * Returns a property used by productMixin to get the product data.
         */
        currentProduct() {
            return this.getProductByName('.nl');
        }
    },
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            confirmed: false
        };
    },
    methods: {
        /**
         * Close the modal.
         */
        closeModal() {
            this.$emit('close');
        },

        /**
         * Enable private whois for domain.
         */
        enablePrivateWhois() {
            WhoisApi.enablePrivateWhois(this.domain)
                .then(() => {
                    EventBus.$emit('notification', {
                        type: 'success',
                        message: trans('action.updated')
                    });

                    // Refresh
                    WhoisApi.get(this.domain);
                })
                .catch(() => {
                    EventBus.$emit('notification', {
                        type: 'error',
                        message: trans('message.error.general')
                    });
                });

            this.$emit('close');
        }
    }
};
</script>
